/* eslint-disable camelcase */
import { roundedToFixed } from '../../../utils/number';
import spAddToWishList from '../../../vendor/googletagmanager/spevents/spaddtowishlist';
import messenger from '../../shared/messenger';
import heart from './heart';
import * as wishlist from './manager';

function formatDataForEvent({ itemCategoryChild, itemCategoryParent, itemId, itemName, itemPrice }) {
    return {
        item_name: itemName,
        item_id: itemId,
        item_variant: 'unknown',
        item_parent_reporting_category: itemCategoryParent,
        item_child_reporting_category: itemCategoryChild,
        item_autoship: 'no',
        item_smartpak: 'no',
        price: roundedToFixed(itemPrice.replace('$', '')),
        quantity: '1'
    };
}

export default function wishlistToggle() {
    const toast = messenger.init();

    const onChange = async ({ id, active, disable, enable, $element }) => {
        let content;        

        disable();

        if (active) {
            content = 'Item was added to your wishlist';
            await wishlist.add(id);
            spAddToWishList(formatDataForEvent($element.closest('[data-item-id]').dataset));
        } else {
            content = 'Item was removed from your wishlist';
            await wishlist.remove(id);
        }

        enable();

        toast.add({
            type: 'confirm',
            content,
            immediate: true
        });
    };

    wishlist.list()
        .then(list => {
            const ids = list.map(item => item.ProductClassId);

            [...document.querySelectorAll('[data-heart]')]
                .forEach($element => heart({
                    $element,
                    ids,
                    onChange
                }));
        });
}

















































